import Log from './log'
export default Log
